import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import Toggle from '../../../../_shared/components/Toggle';
import convertToCurrency from '../../../../_shared/utils/convertToCurrency';
import BidBoxContext from '../../BidBoxContainer/BidBoxContext';
import {
  StyledFormItem,
  StyledBidForm,
  StyledInputs,
  StyledControls,
  StyledToggleMessageContainer,
  StyledToggleContainer
} from './Styles';

const BidFormActive = ({
  onProxyToggleChange,
  bidIncrements,
  bidAmount,
  minBidAmount,
  isToggleChecked,
  formErrors,
  onBidAmountChange
}) => {
  const { bidContext } = useContext(BidBoxContext);
  const { isAuctionEnded } = bidContext;
  return (
    <StyledBidForm isAuctionEnded={isAuctionEnded}>
      <StyledInputs>
        <StyledFormItem>
          <StyledFormItem.Label variant={formErrors.ERROR_BID && 'error'}>
            <FormattedMessage id="vdp.bid.bidAmount" />
          </StyledFormItem.Label>
          <StyledFormItem.Input
            type="number"
            data-testid="bid-amount-overview"
            min={minBidAmount}
            step={bidIncrements}
            value={bidAmount ? String(bidAmount) : ''}
            disabled={isAuctionEnded}
            placeholder={`Minimum ${convertToCurrency(minBidAmount)}`}
            variant={formErrors.ERROR_BID && 'error'}
            onChange={e => {
              onBidAmountChange(e.target.value);
            }}
          />
        </StyledFormItem>
      </StyledInputs>
      <StyledControls>
        <StyledFormItem.Label>
          <StyledToggleMessageContainer>
            <FormattedMessage id="vdp.bidOverview.form.setProxy" />
          </StyledToggleMessageContainer>
        </StyledFormItem.Label>
        <StyledFormItem.Wrapper>
          <StyledToggleContainer>
            <Toggle
              testId="bidBox-proxy-toggle"
              onClick={!isAuctionEnded ? onProxyToggleChange : null}
              isChecked={isToggleChecked}
              byPassUpdate
            />
          </StyledToggleContainer>
        </StyledFormItem.Wrapper>
      </StyledControls>
    </StyledBidForm>
  );
};

export default BidFormActive;
